import { Modal } from 'bootstrap';

$(function () {
    $('#home-contact-form').on('submit', function (e) {
        e.preventDefault();
        const $this = $(this);
        if (!$this[0].checkValidity()) {
            e.preventDefault();
            e.stopPropagation();
            $this[0].classList.add('was-validated');
            return;
        }
        const fullname = $('#txt-home-contact-fullname');
        const email = $('#txt-home-contact-email');
        const message = $('#txt-home-contact-message');
        const domain = $('#domain').val();
        const btnSend = $('#btn-home-contact');
        btnSend.prop('disabled', true);
        btnSend.html('Enviando...');
        const modal = new Modal(document.getElementById('modal-home-contact'), {});
        const modalBody = $('#modal-home-contact-body');
        $.ajax({
            type: "POST",
            url: `${domain}/ajax`,
            data: `tipo=home_contact_form&fullname=${encodeURIComponent(fullname.val())}&email=${encodeURIComponent(email.val())}&message=${encodeURIComponent(message.val())}`,
            success: function () {
                modalBody.html('<h3 class="text-center">¡Gracias por contactarnos!</h3>');
                modal.show();
                btnSend.html('Enviar consulta');
                btnSend.prop('disabled', false);
                $this[0].classList.remove('was-validated');
                fullname.val('');
                email.val('');
                message.val('');
            },
            error: function (a, b, c) {
                console.log(a, b, c);
                
                let message = 'Ha ocurrido un error. Por favor intenta de nuevo.';
                modalBody.html(`<h3 class="text-danger text-center">${message}</h3>`);
                modal.show();
                btnSend.html('Enviar consulta');
                btnSend.prop('disabled', false);
            },
            complete: function () {
                btnSend.prop('disabled', false);
            }
        });
    })
});